import { generatePrintTaximeterHtml } from "./printTemplates/taximeter";
import { generatePrintRenewPermitHtml } from "./printTemplates/permitRenewal";
import { generatePrintPrivateRelocationHtml } from "./printTemplates/privateRelocation";
import { generatePrintRentRelocationHtml } from "./printTemplates/rentRelocation";
import { generatePrintInspectionHtml } from "./printTemplates/vistoria";
import { generatePrintIpiExemptionHtml } from "./printTemplates/ipiExemption";
import { generatePrintIcmsExemptionHtml } from "./printTemplates/icmsExemption";
import { generatePrintPropertyTransferHtml } from "./printTemplates/propertyTranfer";
import { generatePrintFirstRegistrationHtml } from "./printTemplates/firstRegistration";
import { generatePrintTaximeterCalibrationHtml } from "./printTemplates/taximeterCalibration";
import { generatePrintLicensingRenewalHtml } from "./printTemplates/licensingRenewal";
import { generatePrintLicenseHtml } from "./printTemplates/license";

const generators = {
    TAXIMETRO: generatePrintTaximeterHtml,
    ISENCAO_IPI: generatePrintIpiExemptionHtml,
    ISENCAO_ICMS: generatePrintIcmsExemptionHtml,
    TRANSFERENCIA_PROPRIEDADE: generatePrintPropertyTransferHtml,
    MUDANCA_ALUGUEL: generatePrintRentRelocationHtml,
    MUDANCA_PARTICULAR: generatePrintPrivateRelocationHtml,
    VISTORIA: generatePrintInspectionHtml,
    RENOVACAO_ALVARA: generatePrintRenewPermitHtml,
    PRIMEIRO_EMPLACAMENTO: generatePrintFirstRegistrationHtml,
    AFERICAO_TAXIMETRO: generatePrintTaximeterCalibrationHtml,
    RENOVACAO_LICENCIAMENTO: generatePrintLicensingRenewalHtml,
    ALVARA: generatePrintLicenseHtml
};

const defaultGenerator = (_config, data, _user, breakNewPage = false) =>
    `<div class="text-center">Tipo não suportado: ${data.tipo}</div>`;

export function getPrintTemplate(tipo) {
    return generators[tipo] || defaultGenerator;
}
